export default __webpack_public_path__ + "static/media/chatgpt_history_en.cfcf0c53.png";